import { BrowserRouter, Route, Routes } from "react-router-dom";
import Register from "./layout/Register/Register";
import SetPassword from "./layout/SetPassword/SetPassword";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Register />} />
        <Route path="/set-password" element={<SetPassword />} />
        <Route path="*" element={<Register />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
